import { useReducedMotion } from 'framer-motion';

export const useMotionMode = () => {
  const reduced = useReducedMotion();
  return { mode: 'cinematic', reduced, cinematic: !reduced };
};
